export class SystemParams {
  id: number;
  paramName: string;
  paramValue: string;
  paramValueText: string;
  paramOrder: number;
  paramDescriptionFr: string;
  paramDescriptionEn: string;
  paramDescriptionDu: string;
  paramType: string;
  displayInConfig: boolean;
  allowedValues: string;
  notUsed: boolean;
}
